var _rect, _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNextBurnSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 8,
    fill: "url(#paint0_linear_5145_24902)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5145_24902)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 31C20.0109 31 18.1032 30.2098 16.6967 28.8033C15.2902 27.3968 14.5 25.4891 14.5 23.5C14.5 16.75 22 12.25 22 12.25C22 12.25 29.5 16.75 29.5 23.5C29.5 25.4891 28.7098 27.3968 27.3033 28.8033C25.8968 30.2098 23.9891 31 22 31ZM22 31C21.0054 31 20.0516 30.6049 19.3483 29.9016C18.6451 29.1984 18.25 28.2446 18.25 27.25C18.25 23.5 22 21.25 22 21.25C22 21.25 25.75 23.5 25.75 27.25C25.75 28.2446 25.3549 29.1984 24.6517 29.9016C23.9484 30.6049 22.9946 31 22 31Z",
    stroke: "#1B202C",
    strokeOpacity: 0.3,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5145_24902",
    x1: 0,
    y1: 0,
    x2: 44,
    y2: 44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B202C",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B202C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5145_24902"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextBurnSquare);
export default __webpack_public_path__ + "static/media/next-burn-square.cf2fba0da21cbbdb434128585fb9ec14.svg";
export { ForwardRef as ReactComponent };